/**
 * @lodex-pro/web-portal/routes/PremiumStub — the "not on your plan" placeholder.
 *
 * Phase 15 / Task 15.4 (DEC-153) — one locked-feature screen for every plan gate, so users see a
 * consistent UX whichever gate they hit. NO fake API keys, NO fake webhooks (user directive).
 *
 * OPP PR 6 — volumes, tanks, API access, tank setup and routes follow the operator's plan
 * features, so the screen says "not on your company's plan" with no tier name (§58).
 * OPP PR 13a — custom reports and webhooks, the two placeholders that still locked by tier, were
 * removed with their nav and Home tiles until they ship as real plan features.
 */

import React from 'react';

export interface PremiumStubProps {
  readonly feature: 'api-keys' | 'volumes' | 'tanks' | 'tank-setup' | 'routes' | 'reports';
}

const FEATURE_LABEL: Record<PremiumStubProps['feature'], string> = {
  'api-keys': 'API access',
  volumes: 'Volume reports',
  tanks: 'Tank levels & trends',
  // OPP PR 7 — both under OP_ROUTES_PUMPERS.
  'tank-setup': 'Tank setup',
  routes: 'Routes',
  // Operator Reports (c), 0256 — the statement, under OP_REPORTS.
  reports: 'Reports',
};

export function PremiumStub({ feature }: PremiumStubProps): React.JSX.Element {
  const label = FEATURE_LABEL[feature];
  return (
    <main style={{ padding: '32px', maxWidth: '640px', margin: '0 auto' }}>
      <h1 style={{ marginBottom: '16px' }}>{label}</h1>
      <div
        role="status"
        style={{
          padding: '24px',
          background: 'var(--color-bg-tertiary)',
          border: '1px solid var(--color-border-secondary)',
          borderRadius: '10px',
        }}
      >
        <p style={{ margin: 0, marginBottom: '12px', fontWeight: 600 }}>
          🔒 This isn&apos;t on your company&apos;s plan.
        </p>
        <p style={{ margin: 0, color: 'var(--color-text-tertiary)', fontSize: '13px' }}>
          Contact Paelode to add it.
        </p>
      </div>
    </main>
  );
}
